const timestamp = () => {
    return (Date.now || new Date().getTime)()
}

export default timestamp
